<template>
  <div class="extracadabra-landing-layout">
    <div class="row">
      <div class="col" />
      <div class="col-lg-7 col-md-9 col-sm-8 col-xs-11">
        <section class="extracadabra-landing-heading">
          <slot name="heading" />
        </section>

        <section class="extracadabra-landing-content">
          <slot name="content" />
        </section>
      </div>
      <div class="col" />
    </div>
  </div>
</template>

<script>
export default {};
</script>
